<template>
    <div class="page">
        <Banner
            :background-image="$config.campaignLandingPageBannerOverride ? `${ $store.state.imagesCdn }/${ $config.campaignLandingPageBannerOverride.staticImagePath }`: `${ $store.state.imagesCdn }/default-banner-marquee-lt.jpg`"
            :class="{ 'campaign-landing-page-banner--override' : $config.campaignLandingPageBannerOverride }"
            class="campaign-landing-page-banner"
        >
            <div
                class="banner__title"
                v-html="$config.campaignLandingPageBannerOverride ? $config.campaignLandingPageBannerOverride.title : '<div>Get into the biggest concerts and the hottest shows!</div>'">
            </div>
            <div>
                <div
                    class="banner__tagline"
                    v-html="$config.campaignLandingPageBannerOverride ? $config.campaignLandingPageBannerOverride.tagline : 'See your favorite artists, comedians and performers live'">
                </div>
                <router-link
                    v-if="($config.campaignLandingPageBannerOverride || {}).termsModal"
                    class="banner_terms-link"
                    :to="{ query: updateQueryParams($route.query, { modal: 'terms' }) }">
                        Terms
                </router-link>
            </div>

        </Banner>
        <section class="music-section">
            <h2 class="section-header">Shop the Hottest Tours</h2>
            <transition
                mode="out-in"
                name="fade"
            >
                <section v-if="!isLoading.musicEvents">
                    <transition-group
                        class="event-list"
                        name="list"
                        tag="ul"
                    >
                        <li
                            class="performer-tile"
                            v-for="musicEvent in orderedEventList.music"
                            :key="musicEvent.id"
                        >
                            <promotedEvent
                                @click.native="eventSelected(musicEvent.name)"
                                :images="musicEvent.images"
                                :artist-name="musicEvent.name"
                                :event-count="musicEvent.numberOfEvents"
                                :artist-id="musicEvent.id"
                            />
                        </li>
                    </transition-group>
                    <button
                        v-if="isMoreEventsAvailable('music')"
                        class="show-more"
                        @click="fetchMorePerformers('music')"
                    >
                        {{ showMoreButtonCopy('music') }}
                    </button>
                </section>
                <section
                    class="loading"
                    v-else-if="isLoading.musicEvents"
                >
                    <fx-spinner/>
                </section>
            </transition>
        </section>

        <hr class="section-divider">

        <section class="theatre-section">
            <h2 class="section-header">Shop the Biggest Shows</h2>
            <transition
                mode="out-in"
                name="fade"
            >
                <section v-if="!isLoading.theatreEvents">
                    <transition-group
                        class="event-list"
                        name="list"
                        tag="ul"
                    >
                        <li
                            class="performer-tile"
                            v-for="theatreEvent in orderedEventList.theatre"
                            :key="theatreEvent.id"
                        >
                            <promotedEvent
                                @click.native="eventSelected(theatreEvent.name)"
                                :artist-id="theatreEvent.id"
                                :artist-name="theatreEvent.name"
                                :event-count="theatreEvent.numberOfEvents"
                                :images="theatreEvent.images"
                            />
                        </li>
                    </transition-group>
                    <button
                        v-if="isMoreEventsAvailable('theatre')"
                        class="show-more"
                        @click="fetchMorePerformers('theatre')">
                            {{ showMoreButtonCopy('theatre') }}
                        </button>
                </section>
                <section
                    class="loading"
                    v-else-if="isLoading.theatreEvents"
                >
                    <fx-spinner/>
                </section>
            </transition>
        </section>
        <modal
            class="terms-modal"
            v-if="($config.campaignLandingPageBannerOverride || {}).termsModal"
            size="large"
            :open="isTermsModalOpen"
            @close="closeModal">
            <h1 v-html="$config.campaignLandingPageBannerOverride.termsModal.header" class="terms-modal-heading"></h1>
            <div v-html="$config.campaignLandingPageBannerOverride.termsModal.content"></div>
        </modal>
    </div>
</template>

<script>
import { EVENT_NAME, CAMPAIGN_LANDING_PAGE } from 'core/constants/googleAnalyticEvents'
import Banner from '../components/BannerComponent.vue'
import fxSpinner from 'core/components/SpinnerComponent.vue'
import modal from 'core/components/ModalComponent.vue'
import promotedEvent from '../components/PromotedEvent.vue'
import Utils from 'core/utilities/Utils.js'

export default {
    components: {
        Banner,
        fxSpinner,
        modal,
        promotedEvent

    },
    data () {
        return {
            events: {
                music: this.$config.promoted_events[0].children,
                theatre: this.$config.promoted_events[1].children
            },
            isLoading: {
                moreMusicEvents: false,
                moreTheatreEvents: false,
                musicEvents: true,
                theatreEvents: true
            },
            isTermsModalOpen: false,
            page: {
                music: 1,
                theatre: 1
            },
            pageSize: {
                music: 6,
                theatre: 6
            },
            htmlPageTitle: 'Hot Tours'
        }
    },
     head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    computed: {
        orderedEventList () {
            return {
                music: this.events.music.filter(performer => {
                    return Boolean(performer.images && performer.numberOfEvents)
                }),
                theatre: this.events.theatre.filter(performer => {
                    return Boolean(performer.images && performer.numberOfEvents)
                })
            }
        }
    },
    methods: {
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        closeModal () {
            const query = Object.assign({}, this.$route.query)
            delete query.modal
            this.$router.replace({ query })
        },
        eventSelected (performerName) {
            this.$googleTagManager.pushEvent(EVENT_NAME, Object.assign({}, CAMPAIGN_LANDING_PAGE.PERFORMER_TILE_SELECTED, { value: performerName }))
        },
        fetchMorePerformers (type) {
            if (!this.isMoreEventsAvailable(type)) { return }

            this.$googleTagManager.pushEvent(EVENT_NAME, Object.assign({}, CAMPAIGN_LANDING_PAGE.SEE_MORE_BUTTON_SELECTED, { value: type }))
            this.page[type] = this.page[type] + 1
            this.fetchPerformers(type, this.events[type].slice((this.page[type] - 1) * this.pageSize[type], this.page[type] * this.pageSize[type]))
        },
        fetchPerformers (type, performers) {
            this.isLoading[`${type}Events`] = this.page[type] === 1
            this.isLoading[`more${this.capitalizeFirstLetter(type)}Events`] = !this.isLoading[`${type}Events`]

            this.$marketplace
                .getPerformersEvents({ performer_ids: this.formatPerformers(performers) })
                .then(response => {
                    const performers = response

                    performers.forEach(performer => {
                        Object.assign(
                            this.events[type].find(promotedPerformer => Number(promotedPerformer.id) === Number(performer.performer.id)),
                            {
                                images: {
                                    square: performer.performer.images.square.url,
                                    rectangle: performer.performer.images.rectangle.url
                                },
                                numberOfEvents: performer.doc_count
                            }
                        )
                    })
                })
                .finally(() => {
                    this.isLoading[`${type}Events`] = false
                    this.isLoading[`more${this.capitalizeFirstLetter(type)}Events`] = false
                })
        },
        formatPerformers (performers) {
            const joinedParams = []
            performers.forEach(performer => {
                joinedParams.push(performer.id)
            })
            return joinedParams.join()
        },
        isMoreEventsAvailable (type) {
            return Boolean(this.page[type] * this.pageSize[type] < this.events[type].length)
        },
        showMoreButtonCopy (type) {
            const copy = type === 'music' ? 'moreMusicEvents' : 'moreTheatreEvents'
            if (this.isLoading[copy]) { return 'Loading More Events...' }
            if (this.$store.state.isMobile) { return 'More' }
            return 'Show more'
        },
        updateQueryParams: Utils.updateQueryParams
    },
    created () {
        this.fetchPerformers('music', this.events.music.slice((this.page.music - 1) * this.pageSize.music, this.page.music * this.pageSize.music))
        this.fetchPerformers('theatre', this.events.theatre.slice((this.page.theatre - 1) * this.pageSize.theatre, this.page.theatre * this.pageSize.theatre))
    },
    watch: {
        $route: {
            immediate: true,
            handler () {
                this.isTermsModalOpen = this.$route.query.modal === 'terms'
            }
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.page {
    margin: 0 auto;
    max-width: 960px;
    padding: 0 var(--site-padding) 24px var(--site-padding);
    transition-delay: 0.5s;
    transition: all 0.75s ease-out;
}

.merchandising-banner {
    margin-bottom: 30px;
    overflow: hidden;

    & img {
        display: block;
        max-width: 100%;

        &.merchandising-banner__img--desktop {
            display: none;
        }
    }

    @media (--mq-large-min) {
        & img {
            &.merchandising-banner__img--desktop {
                display: block;
            }

            &.merchandising-banner__img--mobile {
                display: none;
            }
        }
    }
}

>>>.campaign-landing-page-banner {
    &.banner {
        background-color: var(--c-header-gradient-left);
        background-position:center;
        background-repeat: no-repeat;
        background-size: auto;
        height: auto !important;
        margin: 0 0 0 -16px;
        padding: 16px;

        @media (--mq-large-min) {
            height: 160px !important;
        }

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            background-image: none !important;
        }

        & .banner__title {
            display: block;
            font-size: 20px;
            font-weight: 500;
            margin: 0;
            padding-bottom: 16px;
            text-shadow: 0 0 4px #000000;

            @media (--mq-large-min) {
                display: flex;
                font-size: 24px;
                margin: 0 0 16px 0;
                padding-bottom: 0;

                & div {
                    padding: 0 3px;
                }
            }
        }

        & .banner__tagline {
            font-size: 14px;
            font-weight: 300;
            letter-spacing:0.005em;
            text-shadow: 0 0 4px #000000;

            @media (--mq-large-min) {
                font-size: 16px;
            }
        }

        & .banner_terms-link {
            color: #ffffff;
            float: right;
            font-size: 14px;
            font-weight: 300;
            letter-spacing:0.005em;
            padding-right: 16px;
            text-shadow: 0 0 4px #000000;

            @media (--mq-large-min) {
                font-size: 16px;
            }
        }

        &.campaign-landing-page-banner--override {
            background-color: transparent;
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                background-color: var(--c-header-gradient-left);
            }
        }
        @media (--mq-large-min) {
            margin: 24px 0 24px 0;
        }
    }
}

.event-list {
    display: block;
    margin: 0;

    @media (--mq-large-min) {
        display: flex;
        flex-wrap: wrap;
        margin-left: -24px;
    }
}

.performer-tile {
    border-radius: 8px;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,0.2);
    margin-bottom: 8px;
    margin-left: 0;

    @media (--mq-large-min) {
        margin-bottom: 24px;
        margin-left: 23px;
    }
}

.show-more {
    background: #FFFFFF;
    border-radius: 2px;
    border: solid 1px var(--c-primary);
    color: var(--c-primary);
    display: block;
    font-size: 16px;
    height: 40px;
    margin: 16px auto 0;
    max-width: 696px;
    transition: 0.2s ease;
    width: calc(100% - 32px);

    @media (--mq-large-min) {
        height: 32px;
        margin: 0 auto;
        width: 100%;

    }

    &:hover {
        background: #F0F0F0;
        color: var(--c-primary);
    }
    &:active {
        background: color(var(--c-primary) shade(20%));
        color: white;
    }
}

.loading {
    height: 650px;
    position: relative;
    width: 100%;
}

.section-header {
  color: var(--c-gray-1);
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0;
  margin: 0 0 6px 0;

  @media (--mq-large-min) {
      font-size: 24px;
  }
}

.music-section {
    background: #FFFFFF;
    margin: 0 -16px;
    padding: 16px;

    @media (--mq-large-min) {
        background: #f4f4f4;
    }
}

.theatre-section {
    margin-top: 24px;
}

.section-divider {
    display: none;
    @media (--mq-large-min) {
        display: block;
        margin-top: 16px;
    }
}

>>> .modal-component {
    & .content {
        color: #353639;
        font-size: 14px;
        font-weight: 300;
        line-height: 16px;
        text-align: center;
        width: 100%;
    }

    & .terms-modal-heading {
        color: #454F62;
        font-size: 20px;
        font-weight: 300;
        letter-spacing: -0.25px;
        line-height: 24px;
        margin-bottom: 0 0 18px 0;
        text-align: center;

        @media (--mq-large-min) {
            font-size: 32px;
            letter-spacing: -0.4px;
            line-height: 32px;
        }
    }

}
/* transitions */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.list-enter-active,
.list-leave-active {
    transition: all 1s;
}

.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>
